import { createFileRoute } from "@tanstack/react-router";
import ShowroomIntro from "lib/components/showroom2/pages/ShowroomIntro";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import { useProducts } from "lib/security/client";
import { useUserContext } from "lib/state/UserContextProvider";

function Showroom2Intro() {
  const { builderId, planId, lotId } = useAppRouterParams();
  const { builder, builderLoading } = useUserContext();

  useProducts(builder, !!builderLoading, ["showroom"]);

  const showroomKey = [builderId, planId, lotId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomProvider key={showroomKey}>
      <ShowroomIntro />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/showroom/intro")({
  component: Showroom2Intro,
  staticData: { isPublicPage: true },
});
